import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import DocumentNavigation from 'components/DocumentNavigation/DocumentNavigation';
import DocumentsSubHeader from 'components/DocumentsSubHeader';
import GeneralMUITableWrapper from 'components/GeneralMUITableWrapper';
import { DocumentNavigationTitles } from 'constants/documentsNavigation';
import { PDF_TYPE } from 'constants/general';
import ROUTES from 'constants/routes';
import useDocumentsStatuses from 'hooks/useDocumentsStatuses';
import { RootStateType } from 'store/reducers';
import { ListingViewsTabs, TableRowsType } from 'types/Mui';
import { createTableData } from 'utils/dataColumns';

export const PDFList = () => {
  const { documents, documentsExecuted } = useSelector((state: RootStateType) => state.user);
  const [documentsRows, setDocumentsRows] = useState<TableRowsType>([]);

  const {
    isUserReadOnly,
    activeStatuses,
    setActiveStatuses,
  } = useDocumentsStatuses();

  useEffect(() => {
    if (activeStatuses.length > 0) {
      setDocumentsRows(createTableData(documentsExecuted, PDF_TYPE, activeStatuses));
    } else {
      setDocumentsRows(createTableData(documents, PDF_TYPE));
    }
  }, [documents, activeStatuses, documentsExecuted]);

  return (
    <>
      <DocumentsSubHeader
        title="PDFs"
        buttonText="Create PDF Template"
        buttonLink={ROUTES.PDF_EDITOR}
        secondButtonText="Single PDF"
        secondButtonLink={ROUTES.PDF_EXECUTED_EDITOR_SINGLE}
      />
      <DocumentNavigation
        activeTab={activeStatuses}
        setActiveTab={setActiveStatuses}
        firstTabTitle={DocumentNavigationTitles.ALL_PDFS}
        isUserReadOnly={isUserReadOnly}
      />
      <div className="w-75 mx-auto pb-5">
        <GeneralMUITableWrapper
          tableRows={documentsRows}
          isAllDocumentsTab={!activeStatuses.length}
          currentTableTab={ListingViewsTabs.PDFS}
          setActiveTab={setActiveStatuses}
          activeStatuses={activeStatuses}
        />
      </div>
    </>
  );
};

export default PDFList;